<button
  id="menu-button"
  aria-haspopup="true"
  aria-controls="menu"
  class="menu-button"
  [ngClass]="{ 'menu-button--open': isOpen }"
  (click)="_toggle()">
  @if (!isOpen) {
    <mat-icon class="material-symbols-rounded size-6 pointer-events-none">
      menu
    </mat-icon>
  } @else {
    <mat-icon class="material-symbols-rounded size-6 pointer-events-none">
      close
    </mat-icon>
  }
</button>
